<script setup>
import { ref } from "vue"
const name = ref('Footer')
</script>

<template>
  <c-footer class="site-footer" text="Copyright © Scania 2024">
    <a
      slot="items"
      href="https://teams.microsoft.com/l/channel/19%3aaead27f3b99c4cf9b0303d5c428fee60%40thread.skype/Product%2520Analytics%2520-%2520Questions?groupId=009a383b-d7c9-42e5-a947-a32fa571402b&tenantId=3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac"
      target="_blank"
    >Contact us</a>
  </c-footer>
</template>

<style scoped>

/* Footer stays at the bottom */
.site-footer {
  width: 100%;
  height: auto;
  margin-top: 30%;
  position: relative;
  bottom: 0;
  text-align: center;
}
</style>
